import { render } from "./IconFolderAdd.vue?vue&type=template&id=12a06498"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconFolderAdd.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "12a06498"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('12a06498', __exports__)) {
    api.reload('12a06498', __exports__)
  }
  
  module.hot.accept("./IconFolderAdd.vue?vue&type=template&id=12a06498", () => {
    api.rerender('12a06498', render)
  })

}


export default __exports__